/**
 * __mocks__/apiResponses/v3/messages.js
 * Autogenerated via generateMockRoute.js
 * DO NOT MODIFY THIS FILE STRUCTURE DIRECTLY.
 */

/** @type {import('../../mockRequestHandler').EndpointMockConfig} */
export default {
  "/communication/:clientId/sms": {
    active: true,
    GET: {
      active: true,
      default: {
        responseValues: {
          response: [
            {
              client_id: "144646",
              created_date: "2025-05-06T10:15:00.000Z",
              family_id: "148326",
              first_name: "Jamie",
              last_name: "Lopez",
              image_url: null,
              message: "Hey! Just wanted to let you know that I need the documents.",
              pkey: 1,
              sender_user_id: "1",
              sender_is_family: false,
            },
            {
              client_id: "144646",
              created_date: "2025-05-06T10:16:00.000Z",
              family_id: "148326",
              first_name: "Emily",
              last_name: "Good",
              image_url:
                "https://an-user-profile-images-staging.s3.amazonaws.com/f3ac7cc3-4c3e-4c1b-a278-06dba1ee1b1b/profile_image.webp",
              message: "Got it, thanks!",
              pkey: 2,
              sender_user_id: "145593",
              sender_is_family: true,
            },
            {
              client_id: "144646",
              created_date: "2025-05-04T13:15:00.000Z",
              family_id: "148326",
              first_name: "Joes",
              last_name: "Tester",
              image_url: null,
              message: "Let’s reschedule to next week if possible.",
              pkey: 3,
              sender_user_id: "1",
              sender_is_family: false,
            },
            {
              client_id: "144646",
              created_date: "2025-05-05T17:00:00.000Z",
              family_id: "148326",
              first_name: "Emily",
              last_name: "Good",
              image_url:
                "https://an-user-profile-images-staging.s3.amazonaws.com/f3ac7cc3-4c3e-4c1b-a278-06dba1ee1b1b/profile_image.webp",
              message: "Looking forward to our session tomorrow!",
              pkey: 4,
              sender_user_id: "145593",
              sender_is_family: true,
            },
            {
              client_id: "144646",
              created_date: "2025-05-05T17:30:00.000Z",
              family_id: "148326",
              first_name: "Emily",
              last_name: "Good",
              image_url:
                "https://an-user-profile-images-staging.s3.amazonaws.com/f3ac7cc3-4c3e-4c1b-a278-06dba1ee1b1b/profile_image.webp",
              message: "We had a great breakthrough today.",
              pkey: 5,
              sender_user_id: "145593",
              sender_is_family: true,
            },
            {
              client_id: "144646",
              created_date: "2025-05-06T12:05:00.000Z",
              family_id: "148326",
              first_name: "Joes",
              last_name: "Tester",
              image_url: null,
              message: "Please send over the updated forms.",
              pkey: 6,
              sender_user_id: "1",
              sender_is_family: false,
            },
            {
              client_id: "144646",
              created_date: "2025-05-13T08:45:00.000Z",
              family_id: "148326",
              first_name: "Jamie",
              last_name: "Lopez",
              image_url: null,
              message:
                "Hi Emily, just checking in on the progress from Monday's session. Let me know if there’s anything else I can help with!",
              pkey: 7,
              sender_user_id: "1",
              sender_is_family: false,
            },
            {
              client_id: "144646",
              created_date: "2025-05-13T09:00:00.000Z",
              family_id: "148326",
              first_name: "Emily",
              last_name: "Good",
              image_url:
                "https://an-user-profile-images-staging.s3.amazonaws.com/f3ac7cc3-4c3e-4c1b-a278-06dba1ee1b1b/profile_image.webp",
              message:
                "Yes, I actually had a chance to review the notes and I think we’re in a good place to move forward with the new plan next week.",
              pkey: 8,
              sender_user_id: "145593",
              sender_is_family: true,
            },
            {
              client_id: "144646",
              created_date: "2025-05-13T09:03:00.000Z",
              family_id: "148326",
              first_name: "Jamie",
              last_name: "Lopez",
              image_url: null,
              message:
                "Sounds great! I’ll prepare the documentation ahead of time to avoid any delays.",
              pkey: 9,
              sender_user_id: "1",
              sender_is_family: false,
            },
            {
              client_id: "144646",
              created_date: "2025-05-14T08:12:00.000Z",
              family_id: "148326",
              first_name: "Emily",
              last_name: "Good",
              image_url:
                "https://an-user-profile-images-staging.s3.amazonaws.com/f3ac7cc3-4c3e-4c1b-a278-06dba1ee1b1b/profile_image.webp",
              message:
                "Perfect. Also, if you get a chance, could you review the intake form again? There were a couple of fields that looked off.",
              pkey: 10,
              sender_user_id: "145593",
              sender_is_family: true,
            },
            {
              client_id: "144646",
              created_date: "2025-05-14T08:17:00.000Z",
              family_id: "148326",
              first_name: "Joes",
              last_name: "Tester",
              image_url: null,
              message: "Sure thing. I'll take a look this morning and follow up with any changes.",
              pkey: 11,
              sender_user_id: "1",
              sender_is_family: false,
            },
          ],
          status: 200,
        },
      },
      scenarios: {},
    },
    POST: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    PUT: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    DELETE: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
  },
};
